module.exports = __webpack_public_path__ + "media/images/flags/16/Burkina-Faso-f4d2420e86627f771e815d77b02f48a3.png";